module.exports = __webpack_public_path__ + "img/besla-khadra.09e32e2c.png";